import {Object3D, Vector3} from "three";
import {Constructor} from "../../util/constructor-wrapper";

/**
 * Provides attribute resolution for implementations of the Scalable Mixin class
 */
type ScalableMapping<T extends Object3D<any>> = {
    _object: T
}

/**
 * interface of the Scalable feature
 */
export interface Scalable {
    get scale(): Vector3
    set scale(value: Vector3)
}

/**
 * @param base
 * @constructor
 */
export function Scalable< Tbase extends Constructor<ScalableMapping<any>>>(base: Tbase){
    return class extends base {
        get scale(): Vector3 { return this._object.scale }
        set scale(value: Vector3) { this._object.scale.copy(value) }
    };
}